import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupMembersComponent } from './group-members.component';
import { SvgIconModule } from '../svg-icon';
import { ClickOutsideDirectiveModule } from '../../directives/click-outside/click-outside.module';
import { GroupMemberStateIndicatorModule } from '../group-member-state-indicator/group-member-state-indicator.module';



@NgModule({
    declarations: [
        GroupMembersComponent
    ],
    imports: [
        CommonModule,
        SvgIconModule,
        ClickOutsideDirectiveModule,
        GroupMemberStateIndicatorModule
    ],
    exports: [
        GroupMembersComponent
    ]
})
export class GroupMembersModule { }
